/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, ApiPaths, TApiResponse } from '../../../api';
import { ITenant } from '.';

const apiDataProvider = new APIDataProvider();

export const getAppTenant = createAsyncThunk(
  '/tenants/getAppTenant',
  async () => {
    const path = `${ApiPaths.tenants}/app`;
    const response = await apiDataProvider.get<TApiResponse<ITenant>>(path);

    return response.data;
  }
);
